import React from "react";
import { withTheme } from "@material-ui/core/styles"
import { 
  Avatar,
  Badge,
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography, 
  Tooltip,

} from "@material-ui/core"
import TakeAwayIcon from "../../common/assets/smallTakeAwayIcon@3x.png"
import DeliveryIcon from "../../common/assets/smallDeliveryIcon@3x.png"
import AvatarMock from "../../common/assets/profile_icon.png"
let lista = []
class TopCard extends React.PureComponent{
  constructor(props){
    super(props)
    this.state = {}
    
    for(let i = 95;i<105;i++){
      lista.push({points:Math.round(Math.random()*300) ,label:`Soy ${i}, un gran usuario`, img:AvatarMock})
    }
    lista.sort((a,b)=>{return b.points-a.points})
  }

  renderContent(itemList){
    if(itemList&&itemList.length>0){
      return (
        <List>
          {itemList.map((u,i)=>{
            return (
              <ListItem>
                  <Badge badgeContent={u.points} color="primary" max={10000}>
                    <ListItemAvatar>
                      <Avatar src={u.img||AvatarMock}/>
                    </ListItemAvatar>
                    <ListItemText primary={u.label}/>
                    
                </Badge>

              </ListItem> 
            )
          })
          }
        </List>
      )
    }
    return (
      <Typography>No encontramos clientes.</Typography>
    )
  }

  render(){
    const {itemList, title, subheader} = this.props
    return (
      <Card>
        <CardHeader title={title} subheader={subheader}/>
        <CardContent>
          {this.renderContent(itemList)}
        </CardContent>
      </Card>
    )
  }
}

TopCard.defaultProps = {
  itemList:lista,
  title:"Top 10 de clientes"
}

export default TopCard


// WEBPACK FOOTER //
// ./src/components/Stats/TopCard.js